import script from "./pageTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./pageTeam.vue?vue&type=script&setup=true&lang=js"

import "./pageTeam.vue?vue&type=style&index=0&id=0cfa4ab6&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cfa4ab6"]])

export default __exports__